import * as React from 'react';
import { Input as TextInput, Textarea } from '../../../components/ui';
import { Switch } from '../../../components/ui';
import { Controller, useFormContext } from 'react-hook-form';
import { MediaComponent } from '../../components/media';
import { TranslateMediaValueToFileProps } from '../../../utils';
import { RadioGroupContainer } from './PlanFormComponent.style';
import InputColor from 'react-input-color';
import { Card, RadioGroup } from '../../elements';
import { usePlanFormInfo } from './PlanFormInfo.use-case';
import { PlanFormInfoProps } from './PlanFormInfo.type';
import { FileProps } from '../../types/Upload.type';
import { PlanFormValues } from './PlanFormInfo.type';

export const PlanFormInfoComponent: React.FC<PlanFormInfoProps> = ({ 
  plan, 
  onPlanChange, 
  onImageUpload 
}) => {
  const _useUseCase = usePlanFormInfo({ initialPlan: plan, onPlanChange: onPlanChange, onImageUpload: onImageUpload });
  
  const {
    enabledColor,
    handleColorChange,
    handleSwitchChange,
    handleImageUpload,
    planInfo
  } = _useUseCase;

  const form = useFormContext<PlanFormValues>();

  const coverUrl = plan.cover?.uri || plan.coverUrl || '';
  
  const PlanInfoHeader = (
    <>
      <p>
        <span>Informações do plano</span>
      <br/>
        {!!planInfo.code && <small><span>código do plano:</span> <code>{planInfo.code}</code></small>}
      </p>
    </>
  );

  const handleMediaUpdate = (mediaType: 'image' | 'video', url: string) => {
    if (mediaType === 'image') {
      const fileProps: FileProps = {
        path: url,
        preview: url
      };
      handleImageUpload(fileProps);
    }
  };

  return (
    <div className="row">
      <div className="col s12">
        <Card title={PlanInfoHeader}>
          <div className="row">
            <div className="col s12 m6">
              <div className="row">
                <div className="col s12">
                  <div className="flow-text">Imagem do plano</div>
                </div>
                <div className="col s12">
                  {/* We're wrapping MediaComponent but not actually using the Controller's field value
                     as MediaComponent handles its own state through the handleMediaUpdate callback */}
                  <MediaComponent 
                    handleMediaUpdate={handleMediaUpdate}
                    coverUrl={coverUrl?.includes('missing') ? '' : coverUrl}
                    videoUrl=""
                    control={form.control}
                  />
                </div>
              </div>
              
              <label>Habilitar cor</label>
              <div className="flex" style={{
                display: 'flex',
                gap: '10px',
              }}>
                <Switch
                  id="enabledColor"
                  offLabel="Off"
                  onLabel="On"
                  checked={enabledColor}
                  onChange={handleSwitchChange}
                />
                {enabledColor && (
                  <Controller
                    name="color"
                    control={form.control}
                    render={({ field }) => (
                      <InputColor
                        initialValue={field.value || "#5e72e4"}
                        onChange={handleColorChange}
                        placement="right"
                      />
                    )}
                  />
                )}
              </div>
            </div>
            
            <Controller
              name="name"
              control={form.control}
              render={({ field, fieldState: { error } }) => (
                <TextInput
                  s={12}
                  m={6}
                  {...field}
                  ref={undefined}
                  error={error?.message as string}
                  inputClassName={error ? 'invalid' : ' '}
                  label="Nome do plano*"
                />
              )}
            />
            
            <Controller
              name="description"
              control={form.control}
              render={({ field }) => (
                <Textarea
                  s={12}
                  m={6}
                  {...field}
                  ref={undefined}
                  placeholder="Descreva o plano, o que você oferece..."
                  label="Descrição do plano"
                />
              )}
            />
          </div>
          
          <div className="row">
            <div className="col s12">
              <RadioGroupContainer>
                <Controller
                  name="planType"
                  control={form.control}
                  render={({ field }) => (
                    <RadioGroup
                      {...field}
                      ref={undefined}
                      label="Tipo do plano"
                      options={[
                        { label: 'Plano Comum', value: 'normal' },
                        { label: 'Por checkin', value: 'checkin' },
                        { label: 'Gympass', value: 'gympass' },
                        { label: 'Totalpass', value: 'totalpass' },
                      ]}
                      withGap
                    />
                  )}
                />
              </RadioGroupContainer>
            </div>
          </div>
          
          <div className="row">
            <div className="col s12">
              <RadioGroupContainer>
                <Controller
                  name="visibility"
                  control={form.control}
                  render={({ field }) => (
                    <RadioGroup
                      {...field}
                      ref={undefined}
                      label="Visibilidade do plano"
                      helper="Escolha este plano só pode ser aplicado pelo painel ou se é público. Planos públicos podem ser contratados pelo seu site, por exemplo"
                      options={[
                        { label: 'Público', value: 'everywhere' },
                        { label: 'Apenas interno', value: 'only_team' },
                      ]}
                      withGap
                    />
                  )}
                />
              </RadioGroupContainer>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}; 